import { ReadOutlined } from '@ant-design/icons';
import { LogoCircle, LogoWrapper } from './Logo.styles';
import Title from 'antd/es/typography/Title';
import React from 'react';


export const Logo = () => {
  return (
    <LogoWrapper>
      <LogoCircle >
        <ReadOutlined />
      </LogoCircle>
      <Title level={4}>PuGongYing IELTS</Title>
    </LogoWrapper>
  );
};